import React, { useState } from 'react';
import { Row, Button } from 'react-bootstrap';
import AffiliatedCompanyForm from './AffiliatedCompanyForm';
import { useTranslation } from 'react-i18next';
import affiliatedCompaniesService from '@rd-web-markets/market/dist/services/affiliated_companies.service';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
const AffiliateCompaniesSection = _ref => {
  let {
    elsterId
  } = _ref;
  const [selectedAffiliatedCompany, setSelectedAffiliatedCompany] = useState(null);
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const [affiliatedCompanies, setAffiliatedCompanies] = affiliatedCompaniesService.useAffiliatedCompanies(elsterId);
  const deleteAffiliatedCompany = async affiliatedCompany => {
    if (window.confirm(t('are_you_sure_you_want_to_remove_this_affiliated_company'))) {
      try {
        await affiliatedCompaniesService.delete(elsterId, affiliatedCompany.id);
        setAffiliatedCompanies([...affiliatedCompanies.filter(ac => ac.id !== affiliatedCompany.id)]);
        setSelectedAffiliatedCompany(null);
      } catch (error) {
        dispatch(handleError(error));
      }
    }
  };
  const createAffiliatedCompany = () => {
    setSelectedAffiliatedCompany({});
  };
  const closeForm = () => {
    setSelectedAffiliatedCompany(null);
  };
  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setSelectedAffiliatedCompany({
      ...selectedAffiliatedCompany,
      [e.target.name]: value
    });
  };
  const editAffiliatedCompany = (e, affiliatedCompany) => {
    e.preventDefault();
    setSelectedAffiliatedCompany(affiliatedCompany);
  };
  const handleSubmit = affiliatedCompaniesService.useSaveAffiliatedCompany(elsterId, setAffiliatedCompanies, setSelectedAffiliatedCompany);
  const AffiliatedCompanyRow = _ref2 => {
    let {
      affiliatedCompany
    } = _ref2;
    return /*#__PURE__*/React.createElement("tr", {
      key: affiliatedCompany.id
    }, /*#__PURE__*/React.createElement("td", null, affiliatedCompany.name), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => editAffiliatedCompany(e, affiliatedCompany)
    }, t('to_affiliate_company_details'))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      onClick: () => deleteAffiliatedCompany(affiliatedCompany),
      className: "mx-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "delete"))));
  };
  if (!affiliatedCompanies) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end pb-3"
  }, !selectedAffiliatedCompany && /*#__PURE__*/React.createElement(Button, {
    onClick: createAffiliatedCompany,
    variant: "primary",
    className: "mx-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add_new_affiliated_company'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("table", {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("th", null, t('affiliates_name')), /*#__PURE__*/React.createElement("th", null, t('open_details')), /*#__PURE__*/React.createElement("th", null, t('delete')))), /*#__PURE__*/React.createElement("tbody", {
    className: "text-center"
  }, affiliatedCompanies.map(affiliatedCompany => /*#__PURE__*/React.createElement(AffiliatedCompanyRow, {
    affiliatedCompany: affiliatedCompany
  }))))), selectedAffiliatedCompany && /*#__PURE__*/React.createElement(AffiliatedCompanyForm, {
    handleChange: handleChange,
    affiliatedCompany: selectedAffiliatedCompany,
    closeForm: closeForm,
    handleSubmit: () => handleSubmit(selectedAffiliatedCompany, affiliatedCompanies)
  }));
};
export default AffiliateCompaniesSection;